// extracted by mini-css-extract-plugin
export default {"band":"styles_band__1DE3B","band--orange":"styles_band--orange__2j-z0","band--yellow":"styles_band--yellow__Val+M"};